import Underline from "../others/Underline";
import colors from "../../config/colors";

function FormSubHeader({
  fontSize = 16,
  color = colors.primary,
  marginTop = 30,
  title = "",
}) {
  return (
    <div style={{ marginTop, fontSize, color }}>
      {title}
      <Underline />
    </div>
  );
}

export default FormSubHeader;
